"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LogLevel_1 = require("./LogLevel");
var BaseLogger = /** @class */ (function () {
    // noinspection TypeScriptAbstractClassConstructorCanBeMadeProtected NO IT CAN'T
    function BaseLogger(_a) {
        var name = _a.name, _b = _a.minLevel, minLevel = _b === void 0 ? LogLevel_1.default.WARNING : _b, _c = _a.emoji, emoji = _c === void 0 ? false : _c, _d = _a.colors, colors = _d === void 0 ? true : _d;
        this._name = name;
        this._minLevel = minLevel;
        this._emoji = emoji;
        this._colors = colors;
    }
    // region convenience methods
    BaseLogger.prototype.crit = function (message) {
        this.log(LogLevel_1.default.CRITICAL, message);
    };
    BaseLogger.prototype.critical = function (message) {
        this.log(LogLevel_1.default.CRITICAL, message);
    };
    BaseLogger.prototype.err = function (message) {
        this.log(LogLevel_1.default.ERROR, message);
    };
    BaseLogger.prototype.error = function (message) {
        this.log(LogLevel_1.default.ERROR, message);
    };
    BaseLogger.prototype.warn = function (message) {
        this.log(LogLevel_1.default.WARNING, message);
    };
    BaseLogger.prototype.warning = function (message) {
        this.log(LogLevel_1.default.WARNING, message);
    };
    BaseLogger.prototype.info = function (message) {
        this.log(LogLevel_1.default.INFO, message);
    };
    BaseLogger.prototype.debug = function (message) {
        this.log(LogLevel_1.default.DEBUG1, message);
    };
    BaseLogger.prototype.debug1 = function (message) {
        this.log(LogLevel_1.default.DEBUG1, message);
    };
    BaseLogger.prototype.debug2 = function (message) {
        this.log(LogLevel_1.default.DEBUG2, message);
    };
    BaseLogger.prototype.debug3 = function (message) {
        this.log(LogLevel_1.default.DEBUG3, message);
    };
    BaseLogger.prototype.trace = function (message) {
        this.log(LogLevel_1.default.TRACE, message);
    };
    return BaseLogger;
}());
exports.default = BaseLogger;
//# sourceMappingURL=BaseLogger.js.map